import { IconGallery } from '@hivebrite/design-system/Icon';

const Gallery = () => <div />; // never used

Gallery.componentCategory = 'block';
Gallery.componentIcon = () => IconGallery;
Gallery.componentLabel = __('Image Galleries');
Gallery.componentName = 'Gallery';
Gallery.componentType = 'section';

Gallery.canBeDoubleClicked = true;
Gallery.canBeDragged = true;
Gallery.canBeListed = true;
Gallery.canBeSelected = true;
Gallery.componentClickable = true;

export default Gallery;
